import { CATEGORY_MODEL_CLASS_NAME } from 'models/daos/category/constants'
import { TAG_MODEL_CLASS_NAME } from 'models/daos/tag/constants'
import { USER_MODEL_CLASS_NAME } from 'models/daos/user/constants'

const LOG_MODEL_CLASS_NAME = 'Log'

const LOG_MODEL_KEY = {
  TYPE: 'type',
  DATA: 'data',
  CATEGORIES: 'categories',
  TAGS: 'tags',
  USER: 'user',
  // Foreign Key
  USER_ID: 'userId',
  // Virtual
  TEXT: 'text'
}

const LOG_MODEL_KEY_POINTER = LOG_MODEL_KEY.ID
const LOG_MODEL_VALIDATOR = {}

/**
 * A mapping of key to placeholder string.
 * @type {Object}
 */
const LOG_MODEL_PLACEHOLDER = {
  [LOG_MODEL_KEY.TYPE]: 'Example Article',
  [LOG_MODEL_KEY.DATA]: '',
  [LOG_MODEL_KEY.USER]: ''
}

/**
 * A mapping of property key to className.
 * @type {Object}
 */
const LOG_MODEL_ASSOCIATION = {
  [LOG_MODEL_KEY.CATEGORIES]: CATEGORY_MODEL_CLASS_NAME,
  [LOG_MODEL_KEY.TAGS]: TAG_MODEL_CLASS_NAME,
  [LOG_MODEL_KEY.USER]: USER_MODEL_CLASS_NAME
}

export {
  LOG_MODEL_CLASS_NAME,
  LOG_MODEL_KEY,
  LOG_MODEL_KEY_POINTER,
  LOG_MODEL_VALIDATOR,
  LOG_MODEL_PLACEHOLDER,
  LOG_MODEL_ASSOCIATION
}
